import { cn } from '../../../lib/utils';
import type { ReportingTabKey } from '../reportingUtils';

const TABS: Array<{ key: ReportingTabKey; label: string; hint: string }> = [
  { key: 'summary', label: 'Overview', hint: 'KPIs & leaderboards' },
  { key: 'onboarding', label: 'Onboarding', hint: 'KYB funnel' },
  {
    key: 'automatedReview',
    label: 'Review',
    hint: 'Policy checks',
  },
  {
    key: 'externalMetrics',
    label: 'External',
    hint: 'Service telemetry',
  },
  { key: 'appList', label: 'Apps', hint: 'Sortable directory' },
  { key: 'individual', label: 'Spotlight', hint: 'Single-app deep dive' },
];

interface ReportingTabsProps {
  activeTab: ReportingTabKey;
  onChange: (tab: ReportingTabKey) => void;
}

export function ReportingTabs({ activeTab, onChange }: ReportingTabsProps) {
  return (
    <div
      role="tablist"
      className="inline-flex flex-wrap rounded-lg border border-neutral-800/70 bg-neutral-950/40 p-0.5"
    >
      {TABS.map((tab) => {
        const isActive = tab.key === activeTab;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            title={tab.hint}
            onClick={() => onChange(tab.key)}
            className={cn(
              'rounded-md px-3 py-1 text-sm font-medium transition-colors',
              isActive
                ? 'bg-neutral-800 text-neutral-100'
                : 'text-neutral-500 hover:text-neutral-300',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
